<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2025-07-08 11:59:14
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-07-10 14:11:21
 * @FilePath: \gov-construction-industry-association-web\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  created() {
    this.initMenu()
  },
  methods: {
    // 初始化菜单保存
    initMenu() {
      this.$store.dispatch('fetchInfo')
    },

  }
}

</script>

<style>
#app {
  box-sizing: border-box;
  overflow-x: initial;
  overscroll-behavior: none;
  max-width: unset;
}
</style>
